import type { LoaderFunctionArgs } from '@remix-run/node';
import { findPlaceByKCoordinates } from '@modules-rocco/location/api/find-place-by-coordinates.server';

export const FIND_PLACE_BY_COORDINATES_ACTION =
    '/actions/location/find-place-by-coordinates';

export const loader = async ({ context, request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const searchParams = url.searchParams;

    const longitudeStr = searchParams.get('longitude');
    const latitudeStr = searchParams.get('latitude');
    if (!longitudeStr || !latitudeStr) return null;

    const longitude = Number(longitudeStr);
    const latitude = Number(latitudeStr);
    if (isNaN(longitude) || isNaN(latitude)) return null;

    return findPlaceByKCoordinates(
        {
            latitude,
            longitude,
        },
        context,
    );
};
